const COUNTRY_CODES = ['US', 'CA'];
export type CountryCode = (typeof COUNTRY_CODES)[number];

export const isCountryCode = (value: unknown): value is CountryCode =>
  typeof value === 'string' && COUNTRY_CODES.includes(value);

export type Currency = 'USD' | 'CAD';

export type ThemeOptions = {
  light: Theme;
  dark: Theme;
};

export type Theme = {
  surface_color: { value: string; label: ThemeLabel };
};

export type ThemeLabel =
  | 'Default'
  | 'Blueberry'
  | 'Blueraspberry'
  | 'Citrus'
  | 'Eggplant'
  | 'Grape'
  | 'Grass'
  | 'Kiwi'
  | 'Persimmon'
  | 'Raspberry'
  | 'Sage'
  | 'Tomato'
  | 'Turquoise'
  | 'Vanilla';
